export default "__VITE_ASSET__82723308__"